import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as RefreshCWAlertIcon } from './refreshCWAlert.svg';

export const RefreshCWAlert = IconHOC(RefreshCWAlertIcon);
